import ErrorIcon from "@mui/icons-material/Error";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import classNames from "classnames";
import { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  selectIsValidationOverlayOpen,
  setIsValidationOverlayOpen,
} from "../../app/slices/GlobalSlice";
import useErrorLogColumn from "./error_log/ErrorLogColumn.hook";
import "./ValidationStatusPill.css";

export default function ValidationStatusPill() {
  const dispatch = useDispatch();
  const isOpen = useSelector(selectIsValidationOverlayOpen);
  const { getLogData } = useErrorLogColumn();
  const logs = useMemo(() => getLogData(), [getLogData]);
  const errorCount = logs.filter((log) => log.logLevel === "error").length;
  const warningCount = logs.length - errorCount;

  if (errorCount === 0 && warningCount === 0) return null;

  return (
    <button
      type="button"
      aria-label={`Open validation issues (${errorCount} errors, ${warningCount} warnings)`}
      className={classNames(
        "validation-status-pill",
        errorCount > 0
          ? "validation-status-pill--errors"
          : "validation-status-pill--warnings",
        {
          "validation-status-pill--active": isOpen,
        }
      )}
      onClick={() => dispatch(setIsValidationOverlayOpen(true))}
    >
      {errorCount > 0 && (
        <span className="validation-status-pill__group validation-status-pill__group--error">
          <ErrorIcon className="validation-status-pill__icon" fontSize="inherit" />
          <span className="validation-status-pill__count">{errorCount}</span>
        </span>
      )}
      {errorCount > 0 && warningCount > 0 && (
        <span className="validation-status-pill__divider" />
      )}
      {warningCount > 0 && (
        <span className="validation-status-pill__group validation-status-pill__group--warning">
          <ReportProblemIcon
            className="validation-status-pill__icon"
            fontSize="inherit"
          />
          <span className="validation-status-pill__count">{warningCount}</span>
        </span>
      )}
    </button>
  );
}
